import { onBeforeUnmount, onMounted } from "vue";
import { isMobile } from "@/shared/utils/mobile";

function isIOS(): boolean {
  const platform =
    (navigator as any)?.userAgentData?.platform || navigator?.platform || "";
  return ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(
    platform
  );
}

export function useFullscreenLandscape() {
  if (!import.meta.client) return;

  const handler = () => {
    const fsEl =
      document.fullscreenElement ||
      (document as any).webkitFullscreenElement ||
      null;

    if (fsEl) {
      if (isMobile() && !isIOS()) {
        const orientation: any = (screen as any).orientation;
        if (orientation?.lock) {
          orientation.lock("landscape").catch(() => {});
        }
      }
    } else {
      const orientation: any = (screen as any).orientation;
      if (orientation?.unlock) {
        try {
          orientation.unlock();
        } catch {}
      }
    }
  };

  onMounted(() => {
    document.addEventListener("fullscreenchange", handler);
    document.addEventListener("webkitfullscreenchange", handler);
  });

  onBeforeUnmount(() => {
    document.removeEventListener("fullscreenchange", handler);
    document.removeEventListener("webkitfullscreenchange", handler);
  });
}
